import { Injectable } from "@angular/core";
import { BaseStyle } from "primeng/base";

@Injectable({ providedIn: "root" })
export class RowdetailsStyle extends BaseStyle {
  override name = "rowdetails";

  override theme = ({ dt }: any): string => `
    .ui-rowdetails {
      display: table-row;
    }

    .ui-rowdetails-outer-cell {
      padding: ${dt("rowdetails.padding")};
    }

    .ui-rowdetails-wrapper {
      display: flex;
      padding: ${dt("rowdetails.table.padding")};
      background: ${dt("rowdetails.table.background")};
    }

    .ui-rowdetails-table {
      table-layout: auto !important; /* just in case, but really because of the p-treetable */
      flex: 1;
    }

    .ui-rowdetails-table > tr {
      border-style: solid;
      border-width: ${dt("rowdetails.row.border.width")};
      border-color: ${dt("rowdetails.row.border.color")};
    }

    .ui-rowdetails-table > tr > td {
      padding: ${dt("rowdetails.cell.padding")};
    }

    .ui-rowdetails-table > tr > td:first-child {
      width: 0; /* so that it takes as less space as possible */
      white-space: nowrap; /* but it also only takes one line */
      font-weight: ${dt("rowdetails.term.font.weight")};
    }
  `;

  override classes = {
    root: "ui-rowdetails",
    outerCell: "ui-rowdetails-outer-cell",
    wrapper: "ui-rowdetails-wrapper",
    table: "ui-rowdetails-table",
  };
}
